(function () {
  'use strict';

  if (window.__setPickerAjaxInit) return;
  window.__setPickerAjaxInit = true;

  var MAIN_ID = 'main';
  var ITEM_SELECTOR = 'a.bundle-selector__item';
  var pageCache = new Map();
  var didSwap = false;

  function fetchPage(url) {
    if (pageCache.has(url)) return Promise.resolve(pageCache.get(url));
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        pageCache.set(url, html);
        return html;
      });
  }

  function reexecuteScripts(container) {
    var scripts = container.querySelectorAll('script');
    for (var i = 0; i < scripts.length; i++) {
      var oldScript = scripts[i];
      var newScript = document.createElement('script');
      for (var j = 0; j < oldScript.attributes.length; j++) {
        var attr = oldScript.attributes[j];
        newScript.setAttribute(attr.name, attr.value);
      }
      newScript.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(newScript, oldScript);
    }
  }

  function swapTo(url) {
    var currentMain = document.getElementById(MAIN_ID);
    if (!currentMain) { window.location.href = url; return; }

    currentMain.classList.add('is-swapping');
    currentMain.setAttribute('aria-busy', 'true');

    fetchPage(url)
      .then(function (html) {
        var newDoc = new DOMParser().parseFromString(html, 'text/html');
        var newMain = newDoc.getElementById(MAIN_ID);
        if (!newMain) { window.location.href = url; return; }

        window.history.pushState({ setPicker: true }, '', url);
        didSwap = true;

        currentMain.innerHTML = newMain.innerHTML;
        reexecuteScripts(currentMain);
        if (newDoc.title) document.title = newDoc.title;
        currentMain.classList.remove('is-swapping');
        currentMain.removeAttribute('aria-busy');

        var current = currentMain.querySelector('[data-set-picker] [aria-current="page"]');
        if (current && typeof current.focus === 'function') current.focus({ preventScroll: true });
        var live = currentMain.querySelector('[data-set-picker-live]');
        if (live) {
          var announce = (current && current.textContent.trim()) || document.title || '';
          setTimeout(function () { live.textContent = announce; }, 100);
        }

        window.dispatchEvent(new CustomEvent('set-picker:swapped', { detail: { url: url } }));
      })
      .catch(function () {
        window.location.href = url;
      });
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }
    var item = event.target.closest(ITEM_SELECTOR);
    if (!item) return;

    var href = item.getAttribute('href');
    if (!href) return;
    if (item.getAttribute('aria-current') === 'page') { event.preventDefault(); return; }

    event.preventDefault();
    swapTo(href);
  });

  window.addEventListener('popstate', function () {
    if (didSwap) window.location.reload();
  });
})();
